import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_ds_lots_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId: number, projectId?: number, materialIds?: number[], fullTextSearch?: string, statusIds?: number[], fromDate?: string, toDate?: string, dateType?: string, lotIds?: number[], vendorLotIds?: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, ModifiedSysDateTime?: string, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { CreatedSysDateTime?: string, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, ModifiedSysDateTime?: string, Notes?: string, Vat?: string }, Status?: { Name?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_lots_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId: number, projectId?: number, materialIds?: number[], fullTextSearch?: string, statusIds?: number[], fromDate?: string, toDate?: string, dateType?: string, lotIds?: number[], vendorLotIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, ModifiedSysDateTime?: string, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { CreatedSysDateTime?: string, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, ModifiedSysDateTime?: string, Notes?: string, Vat?: string }, Status?: { Name?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_lots_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId: number, projectId?: number, materialIds?: number[], fullTextSearch?: string, statusIds?: number[], fromDate?: string, toDate?: string, dateType?: string, lotIds?: number[], vendorLotIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, LastReceiveDate?: string, LookupCode?: string, MaterialId?: number, ModifiedSysDateTime?: string, Notes?: string, ReceiveDate?: string, StatusId?: number, VendorLotId?: number, VendorLot?: { CreatedSysDateTime?: string, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, ModifiedSysDateTime?: string, Notes?: string, Vat?: string }, Status?: { Name?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_lots_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId: number, projectId?: number, materialIds?: number[], fullTextSearch?: string, statusIds?: number[], fromDate?: string, toDate?: string, dateType?: string, lotIds?: number[], vendorLotIds?: number[]    }) {
        if(isNil(inParams.ownerId)) {
          return true; 
        }
      return false;
    }
}
